import * as Yup from 'yup'
import { Col, Form, InputGroup, Row } from 'react-bootstrap'

type Values = {
  rows: number
  marginRows: number
}

type Props = {
  values: Values
  errors: Partial<Record<keyof Values, string>>
  touched: Partial<Record<keyof Values, boolean>>
  handleChange: React.ChangeEventHandler<HTMLElement>
  handleBlur: React.FocusEventHandler<HTMLElement>
  handleSubmit: (values: Values) => void
  isSettingWritable: boolean
  rowIndex: number
}

const _PreambleRowMarginSettingForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  isSettingWritable,
  rowIndex
}: Props) => {
  return (
    <Row sm='auto' className={`row-${rowIndex + 1}`}>
      <Col sm={1}>前文{values.rows}行</Col>
      <Col>
        <InputGroup size='sm' hasValidation>
          <Form.Control
            id='marginRowsInput'
            type='number'
            name='marginRows'
            value={values.marginRows || ''}
            onChange={(e) => {
              handleChange(e)
              handleSubmit(values)
            }}
            onBlur={handleBlur}
            isInvalid={!!(touched.marginRows && errors.marginRows)}
            disabled={!isSettingWritable}
          />
          <InputGroup.Text>行取り</InputGroup.Text>
          <Form.Control.Feedback type='invalid'>{errors.marginRows}</Form.Control.Feedback>
        </InputGroup>
      </Col>
    </Row>
  )
}

export const PreambleRowMarginSettingForm = Object.assign(_PreambleRowMarginSettingForm, {
  schema: Yup.object().shape({
    marginRows: Yup.number().min(1).required()
  })
})
